import { mapGetters, mapActions } from 'vuex';
import format from '@/common/utilities/format';
import mvtChart from '@/common/components/mvtchart/mvt-chart.vue';
export default {
    name: 'mvtMarket',
    inject: ['$eventBus'],
    props: ['cityId', 'countyId', 'state', 'city', 'county'],
    data(){
        return {
            marketData: null
        };
    },
    components: {
        mvtChart
    },
    computed: {
        ...mapGetters('glb', ['glb']),
        chartData(){
            if(!this.marketData){
                return null;
            }
            var maxItem = [];
            var labels = [];
            var datasets = [];
            var data = this.marketData;
            if(data.dailyCityStatisticsList && maxItem.length < data.dailyCityStatisticsList.length){
                maxItem = data.dailyCityStatisticsList;
            }
            if(data.dailyCountyStatisticsList && maxItem.length < data.dailyCountyStatisticsList.length){
                maxItem = data.dailyCountyStatisticsList;
            }
            if(this.dailyStateStatisticsList && maxItem.length < this.dailyStateStatisticsList.length){
                maxItem = data.dailyStateStatisticsList;
            }

            if(!maxItem || !maxItem.length){
                return null;
            }

            var yAxisController = [{
                display: true,
                ticks: {
                    beginAtZero: true,
                    userCallback: function(value, index, values) {
                        return '$' + format.friendlyPrice(value);

                    }
                },
                gridLines: {
                    color: 'rgba(232, 232, 232, 1)'
                }
            }];
            labels = maxItem.map(function(e){
                return e.monthYear;
            });
            var cityData = new Array(labels.length),
            countyData = new Array(labels.length);
            for(var i = 0; i < labels.length; i++){
                var key = labels[i];
                var countyItem = data.dailyCountyStatisticsList.find(function(e){
                    return e.monthYear === key;
                });
                var cityItem = data.dailyCityStatisticsList.find(function(e){
                    return e.monthYear === key;
                });
                cityData[i] = cityItem ? cityItem.allTypeMedianListPrice : NaN;
                countyData[i] = countyItem ? countyItem.allTypeMedianListPrice : NaN;
            }
            var countyLabel = this.county;
            var cityLabel = this.city;
            if (countyData && countyData.length) {
                datasets.push({
                    label: countyLabel,
                    data: countyData,
                    fill: false,
                    borderColor: '#fac100',
                    backgroundColor: '#fac100',
                    borderWidth: 2
                });
            }

            if(cityData && cityData.length){
                datasets.push({
                    label: cityLabel,
                    data: cityData,
                    fill: false,
                    borderColor: '#1F8265',
                    backgroundColor: '#1F8265',
                    borderWidth: 2
                });
            }
            return {
                type: 'line',
                data: {
                    labels: labels,
                    datasets: datasets
                },
                options: {
                    legend: {
                        display: true,
                        position: 'bottom',
                        onClick: (e) => e.stopPropagation()
                    },
                    responsive: true,
                    maintainAspectRatio: false,
                    scales: {
                        yAxes: yAxisController,
                        xAxes: [{
                            display: true,
                            gridLines: {
                            color: 'rgba(0, 0, 0, 0)'
                            }
                        }]
                    },
                    tooltips: {
                        enabled: true,
                        titleAlign: 'center'
                    }
                }
            };
        }
    },
    methods: {
        ...mapActions('glb', ['fetchMarketTrend']),
        inital(){
            var that = this;
            if(this.cityId && this.countyId && this.state){
                this.fetchMarketTrend({
                    cityCode: this.cityId,
                    countyId: this.countyId,
                    state: this.state
                }).then(function(e){
                    that.marketData = e.marketDppData;
                    that.$emit('completed');
                });
            }
        }
    },
    mounted(){
        this.inital();

    },
};
